<template>
  <v-card class="px-3 live-trade-details-card rounded-0" elevation="0"
    :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row dense>
      <v-col cols="12">
        <v-sheet
          class="d-flex align-center mb-lg-4 mb-md-2 mb-2 py-3 px-1 justify-center justify-sm-space-between userBriefHistory flex-column flex-sm-row text-center text-sm-left"
          :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'">
          <div class="title d-flex align-center">
            <v-img class="mr-3" max-width="17" src="@/assets/Dashboard/bar.svg"></v-img>
            <span>Partner List</span>
          </div>

          <!-- <div class="action-btn">
            <v-btn class="text-capitalize mr-3" small elevation="0" outlined color="#708aa7" tile><v-icon small left
                color="#708aa7">
                mdi-arrow-collapse-down
              </v-icon>
              Commission Detail
            </v-btn>
            <v-btn small outlined elevation="0" color="#708aa7" @click.prevent="downloadCSVall" :loading="csvLoading" :disabled="csvLoading" tile class="text-capitalize"><v-icon small left
                color="#708aa7">
                mdi-arrow-collapse-down
              </v-icon>
              All Partner List
            </v-btn>
          </div> -->
        </v-sheet>
      </v-col>
    </v-row>
    <v-row class="no-gutters align-center pr-1">
      <v-col cols="12" sm="6" md="4" lg="3" :sm="$canRoute('partner-list') !== 1 ? 12 : 6" :md="$canRoute('partner-list') !== 1 ? 6 : 4" :lg="$canRoute('partner-list') !== 1 ? 4 : 3">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="4">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <ul class="mt-0">
          <li>
            <span class="">Child</span>
            <span>{{ totalChild }}</span>
          </li>

          <!-- <li>
            <span class="">Volume</span>
            <span>{{ totalVolume }}</span>
          </li> -->
          <li>
            <span class="text--green">IB Commi.</span>
            <span>{{ totalCommission.toFixed(2) }}</span>
          </li>
        </ul>
      </v-col>
      <v-col cols="12" sm="6" md="1" lg="1" v-if="$canRoute('partner-list') === 1">
        <v-btn @click.prevent="downloadCSVall" :loading="csvLoading" :disabled="csvLoading" tile elevation="0" to="" class="text-capitalize btn-account mb-0 mx-0"
          color="greenMain">
          <v-icon small>mdi mdi-tray-arrow-down</v-icon>CSV
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable registerUserTable"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="partnerlist" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.sl="{ index }">
                {{ (parseInt(pagination?.currentPage) - 1) * parseInt(pagination?.perPage || 10) + index + 1 }}
              </template>
              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{ copiedStates[item.id] ? "mdi-check" : "mdi-content-copy" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.email }}</span>
                </v-tooltip>
              </template>
               
              <template v-slot:item.countries="{ item }">
                {{ item?.countries?.name || "N/A" }}
              </template>

              <template v-slot:item.fullname="{ item }" v-if="$canRoute('create-new-user-account') === 1">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.id}`">
                  {{ item.fullname }}
                </router-link>
              </template>

              <template v-slot:item.fullname="{ item }" v-else>
                {{ item.fullname }}
              </template>

              <template v-slot:item.commission_expired_date="{ item }">
                <span v-if="item?.commission_expired_date">
                  {{ formatDateOnly(item.commission_expired_date) }}
                </span>
                <span v-else>N/A</span>
              </template>


              <template v-slot:item.admin_name="{ item }">
                {{ item?.admin_name || "N/A" }}
              </template>
              
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>
              <template v-slot:item.details="{ item }">
                <div class="d-flex justify-space-around">
                  <div class="">
                    <router-link class="links text-decoration-none" :to="`/partner-list-details?id=${item.id}`">
                      <v-icon color="#039de9" small>
                        mdi-eye-outline
                      </v-icon>
                    </router-link>
                  </div>
                </div>
              </template>
              <template v-slot:item.ClientVisibility="{ item }">
                <div class="status-selection status-selection-blocked-user d-flex align-items-center">
                  <v-switch @change="handleStatus(item)" :input-value="Boolean(item.commissionStatus)" inset
                    color="#039de9" :ripple="false">
                  </v-switch>
                </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import { PARTNERLIST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      date: null,
      searchTimeout: null,
      selectedDates: [],
      isLoading: false,
      csvLoading: false,
      selectedDatesText: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      // OLD
      modal: false,
      dialog: false,
      switch1: true,
      copiedStates: {},
      slots: ["India", "Pakistan", "Vutan"],
      slots5: [
        { text: "ON", value: "ON", class: "text-approved" },
        { text: "OFF", value: "OFF", class: "text-decline" },
      ],
      items: [{ text: "IB Level Unlock Setting", link: "" }],
      headers: [
        { text: "SL", value: "sl" },
        { text: "Affiliate ID", value: "id" },
        { text: "Name", value: "fullname" },
        { text: "Email", value: "email" },
        { text: "Expired Date", value: "commission_expired_date" },
        { text: "Country", value: "countries" },
        { text: "Reg. Time", value: "created_at" },
        { text: "Action By", value: "admin_name" },
      ],
    };
  },

  computed: {
    ...mapState("partnerlist", [
      'partnerlist',
      'allpartnerlists',
      'totalCommission',
      'totalVolume',
      'totalChild',
      'pagination'
    ]),
    totalItems() {
      return this.pagination?.total || 0;
    },
    dateRangeText() {
      return this.date.join(" ~ ");
    },
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    formatMySQLDate,
    ...mapActions("partnerlist", [
      PARTNERLIST__ACTIONS.PARTNERLIST,
      PARTNERLIST__ACTIONS.UPDATECOMMISSIONSTATUS,
      PARTNERLIST__ACTIONS.ALLPARTNERLIST,
    ]),

    formatDateOnly(val) {
      if (!val) return null;

      // if it's already "YYYY-MM-DD" => return as is
      if (typeof val === "string") {
        // handles "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ssZ", "YYYY-MM-DD HH:mm:ss"
        return val.split("T")[0].split(" ")[0];
      }

      // fallback: if Date object
      if (val instanceof Date) return val.toISOString().slice(0, 10);

      return String(val).split("T")[0].split(" ")[0];
    },


    copyText(item) {
      navigator.clipboard.writeText(item?.email);
      this.$set(this.copiedStates, item?.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item?.id, false);
      }, 1000);
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email);
    },
    getTextColor(item) {
      return item.class;
    },

    async handleStatus(item) {
      let newStatus = !item.commissionStatus ? 1 : 0;

      this[PARTNERLIST__ACTIONS.UPDATECOMMISSIONSTATUS]({
        partner_id: item.id,
        new_status: newStatus,
      })
      await this.fetchData();
    },

    async downloadCSVall() {
      this.csvLoading = true;
      try {
        const params = {
        page: 1,
        limit: -1,
        search: "",
      };
      await this[PARTNERLIST__ACTIONS.ALLPARTNERLIST](params);
      this.downloadCSV();
      } catch (error) {
        console.log(error);
      }finally {
        this.csvLoading = false;
      }
    },

    downloadCSV() {
      this.csvLoading = true;
      // Define CSV headers exactly as shown in the image
      const headers = [
        'Affiliate ID',
        'Name',
        'Email',
        'Country',
        'Registration',
        'Commission Status',
        'Trading Acc',
        'Total Volume',
        'Total Commission'
      ];

      // Transform data to match exact format
      const csvData = this.allpartnerlists.map(partner => {
        // Get all trading account numbers
        const tradingAccounts = partner.tradingaccounts
          .map(acc => acc.trading_account_no)
          .join(' ');

        // Calculate totals
        const totalVolume = partner.partnerTradeEarning.reduce((sum, trade) => sum + trade.volume, 0);
        const totalCommission = partner.partnerTradeEarning.reduce((sum, trade) => sum + trade.commission, 0);

        // Format date to match DD.MM.YYYY
        const date = new Date(partner.created_at);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;

        return [
          partner.id,
          partner.fullname,
          partner.email,
          partner.countries?.name || 'N/A',
          formattedDate,
          partner.commissionStatus ? 'Active' : 'Inactive',
          tradingAccounts || 'N/A',
          totalVolume || 0,
          totalCommission ? totalCommission.toFixed(1) : 0
        ];
      });

      // Combine headers and data
      const csvContent = [
        headers,
        ...csvData
      ].map(row => row.join(',')).join('\n');

      // Create blob and download link
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `partner-list-${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.csvLoading = false;
    },

    async fetchData() {
      try {
        this.isLoading = true
        const params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          search: this.search,
        };

        if (this.selectedDates?.length === 2) {
          params.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
        }

        await this[PARTNERLIST__ACTIONS.PARTNERLIST](params);
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },


    async handleSearch() {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
    if (this.$canRoute('partner-list') === 1) {
      this.headers.push({ text: "Com. Status", value: "ClientVisibility" });
    }
    this.headers.push({ text: "Details", value: "details" });
  },
};
</script>
